module.exports = __webpack_public_path__ + "static/media/halluxguard-1.89aced36.jpg";